export enum DocsUrls {
  PERSONAL_API_TOKENS = 'https://docs.apono.io/api-reference',
  ACCESS_FLOWS = 'https://docs.apono.io/docs/access-flow',
  ACCESS_BUNDLES = 'https://docs.apono.io/docs/access-bundles',
  CONNECTOR_MANAGEMENT = 'https://docs.apono.io/docs/connector-management',
  WEBHOOKS = 'https://docs.apono.io/docs/webhooks',
  AWS_INLINE_POLICIES_LIMITS = 'https://docs.apono.io/docs/aws-environment/aws-integrations/integrate-an-aws-account-or-organization/aws-limitations',
}
